import { render } from "./Filters.svg?vue&type=template&id=15de2493"
const script = {}
script.render = render

export default script